import {useQuery} from '@tanstack/react-query'
import {useServices} from '@/services/context'
import type {ValueList} from '@/types/value-list'

export interface UseValueListResult {
    list: ValueList | undefined
    isLoading: boolean
    error: Error | null
}

/**
 * Read hook for the ValueListDetail page — fetches the single value list with
 * its embedded entries via `GET /value-lists/{id}`. Returns a stable shape
 * regardless of in-flight state so consumers don't have to defend against
 * `undefined` while loading.
 */
export function useValueList(id: string | undefined): UseValueListResult {
    const services = useServices()

    const query = useQuery<ValueList>({
        queryKey: ['value-list', id],
        queryFn: () => services.valueLists.detail(id!),
        enabled: !!id,
    })

    return {
        list: query.data,
        isLoading: query.isLoading,
        error: (query.error as Error | null) ?? null,
    }
}
